import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface VoucherKarmaState {
  data: any[] | null;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allVoucherKarmaList: any[];
  purposeCodes: any[];
}

const initialState: VoucherKarmaState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allVoucherKarmaList: [],
  purposeCodes: [],
};

export const voucherKarmaSlice = createSlice({
  name: "voucherKarma",
  initialState,
  reducers: {
    setVoucherKarma: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setVoucherKarmaBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllVoucherKarma: (state, action) => {
      state.allVoucherKarmaList = action.payload.data;
    },
    setPurposeCodes: (state, action) => {
      state.purposeCodes = action.payload.data;
    },
    resetVoucherKarma: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  setVoucherKarma,
  setVoucherKarmaBySearch,
  setAllVoucherKarma,
  setPurposeCodes,
  resetVoucherKarma,
} = voucherKarmaSlice.actions;

export const getVoucherKarmaData = (state: RootState) => state.voucherKarma.data;
export const getAllVoucherKarmaList = (state: RootState) => state.voucherKarma.allVoucherKarmaList;
export const getVoucherKarmaTotalRecords = (state: RootState) => state.voucherKarma.totalRecords;
export const getVoucherKarmaDataBySearch = (state: RootState) => state.voucherKarma.data;


export const getPurposeCodesWithAll = (state: RootState) => [
  { id: 0, label: "All" },
  ...(state.voucherKarma.purposeCodes || []),
];


export default voucherKarmaSlice.reducer;
